/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        time = parseInt(time);
      } else {
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split("?")[1]).replace(/\+/g, " ");
  if (!search) {
    return {};
  }
  const obj = {};
  const searchArr = search.split("&");
  searchArr.forEach((v) => {
    const index = v.indexOf("=");
    if (index !== -1) {
      const name = v.substring(0, index);
      const val = v.substring(index + 1, v.length);
      obj[name] = val;
    }
  });
  return obj;
}
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += " " + cls;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
  }
}

export function limitInput(event, decimalPlaces, digitLimit) {
  const input = event.target;
  let value = input.value;
  // 去除非数字和非小数点字符
  value = value.replace(/[^0-9.]/g, "");
  // 确保只有一个小数点
  const parts = value.split(".");
  if (parts.length > 2) {
    value = parts[0] + "." + parts.slice(1).join("");
  }
  // 确保小数点后最多指定的位数
  if (parts.length === 2 && parts[1].length > decimalPlaces) {
    parts[1] = parts[1].slice(0, decimalPlaces);
    value = parts.join(".");
  }
  // 通过字符串判断是否在指定的位数范围内
  const integerPart = parts[0];
  const minValue = "1" + "0".repeat(digitLimit - 1);
  const maxValue = "9".repeat(digitLimit);
  if (integerPart.length < digitLimit) {
    value = minValue;
  } else if (
    integerPart.length > digitLimit ||
    (integerPart.length === digitLimit && integerPart > maxValue)
  ) {
    value = maxValue + "." + "9".repeat(decimalPlaces);
  }
  input.value = value;
}

const attributeList = [
  { value: 1, label: "主要构件" },
  { value: 2, label: "一般构件" },
  { value: 3, label: "主要构件，一般构件" },
  { value: 4, label: "圈梁" },
];

//返回对应的属性
export const getAttributeLabel = (row) => {
  return row.type !== "rlPartitionWallSeg"
    ? row.attribute
      ? row.attribute === 4
        ? row.type === "rlColSeg" || row.type === "柱"
          ? "构造柱"
          : "圈梁"
        : attributeList.find((e) => e.value === row.attribute)?.label
      : "-"
    : "-";
};

export function subtract(a, b) {
  // 找到小数点后最多的位数
  const decimalPlaces = Math.max(
    (a.toString().split(".")[1] || "").length,
    (b.toString().split(".")[1] || "").length
  );
  const multiplier = Math.pow(10, decimalPlaces);

  // 转换为整数计算，再转换回小数
  return (a * multiplier - b * multiplier) / multiplier;
}
